<template>
  <div class="filters position-relative">
    <b-button
      class="round d-flex p-filters"
      @click="onHandShowFilter"
      variant="primary"
    >
      <feather-icon width="24px" height="24px" icon="FilterIcon" />
      <div class="text-filters align-self-center">Filters</div>
    </b-button>
    <b-badge
      variant="light"
      v-if="isClone"
      @click="clearFilter"
      class="d-block align-self-center position-absolute badge-filters round"
    >
      <feather-icon class="text-primary" icon="XIcon" />
    </b-badge>
    <div
      class="mb-2 position-absolute card-body-filters"
      :style="{ width: wigthMenu }"
      v-show="isFilter"
    >
      <div class="body-card font-weight-bold p-2 text-dark">
        <b-card-text style="color: #000"> SELECT STATUS </b-card-text>
        <v-select
          v-for="(item, index) in arrayObject"
          :key="index"
          label="text"
          class="mt-1 style-select"
          :placeholder="'Choose ' + item.text"
          v-model="dataSelect[item.type]"
          :options="item.data"
          :clearable="false"
        />
        <b-button
          href="#"
          class="my-2 float-right round"
          variant="primary"
          @click="onHandShowFilter"
          >Apply</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  components: { vSelect },
  props: ["arrayObject"],
  data() {
    return {
      isFilter: false,
      dataSelect: {},
      isClone: false,
      wigthMenu: "50px",
    };
  },
  created() {
    this.ckeckScreen();

    window.addEventListener("resize", this.ckeckScreen);
  },
  mounted() {},
  watch: {
    dataSelect: {
      handler(val) {
        // do stuff
        Object.keys(this.dataSelect).length > 0
          ? (this.isClone = true)
          : (this.isClone = false);
        this.$emit("select-filter", this.dataSelect);
      },
      deep: true,
    },
  },
  methods: {
    clearFilter() {
      this.dataSelect = {};
    },
    onHandShowFilter() {
      this.isFilter = !this.isFilter;
    },
    ckeckScreen() {
      this.isFilter = false;
      const windowWidth = window.innerWidth;
      const padding = windowWidth < 546 ? 75 : 100;
      windowWidth < 768
        ? (this.wigthMenu = windowWidth - padding + "px")
        : (this.wigthMenu = "450px");
    },
  },
};
</script>
<style lang="scss">
.style-select .vs__dropdown-toggle {
  border-radius: 50px !important;
}
.round.multiselect__tags {
  border-radius: 1.5rem;
}
</style>